import { render, staticRenderFns } from "./purchaseInquiry-add-or-update.vue?vue&type=template&id=27794d11&scoped=true"
import script from "./purchaseInquiry-add-or-update.vue?vue&type=script&lang=js"
export * from "./purchaseInquiry-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./purchaseInquiry-add-or-update.vue?vue&type=style&index=0&id=27794d11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27794d11",
  null
  
)

export default component.exports